/* eslint-disable no-unused-vars */
/* eslint-disable object-shorthand */
/* eslint-disable prefer-destructuring */
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'
import { Table, Modal, Checkbox, DatePicker, Select, Button, Popconfirm } from 'antd'
import { Link } from 'react-router-dom'
import { getArticulosFaltantesAction } from '@redux/articulo/actions'
import { getUsuarioStockManagerAction, patchUsuarioAction } from '@redux/usuario/actions'
import {
  updateArticuloUser,
  updateArticuloUserMostrar,
  updateArticuloAgotar,
} from 'services/catalogo'
import { FieldTimeOutlined } from '@ant-design/icons'
import { useMsal } from '@azure/msal-react'

const mapStateToProps = ({ articulosReducer, usuarioReducer }) => ({
  articulos: articulosReducer.articulos,
  usuarioStock: usuarioReducer.usuarioStock,
})

const mapDispatchToProps = dispatch => {
  return {
    onLoadArticulosFaltantes: () => {
      getArticulosFaltantesAction(dispatch)
    },
    onLoadUsuarioStock: () => {
      getUsuarioStockManagerAction(dispatch)
    },
    patchUsuario: (id, payload) => {
      patchUsuarioAction(dispatch, id, payload)
    },
  }
}

const ModalStockMinimo = ({
  articulos,
  usuarioStock,
  onLoadArticulosFaltantes,
  onLoadUsuarioStock,
  visible,
  setVisible,
  patchUsuario,
}) => {
  const { accounts } = useMsal()
  const userId = accounts[0] && accounts[0].localAccountId

  useEffect(() => {
    onLoadArticulosFaltantes()
  }, [onLoadArticulosFaltantes])

  useEffect(() => {
    onLoadUsuarioStock()
  }, [onLoadUsuarioStock])

  // Lista de usuarios de stock
  const mapUsuariosToSelectOptions = () => {
    return usuarioStock?.data && usuarioStock?.data.length > 0
      ? usuarioStock.data.map(user => {
          return {
            label: user.userName,
            value: user.id,
          }
        })
      : []
  }

  const columns = [
    {
      title: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      render: (text, record) => (
        <Link
          to={`/articulos/edit/${record?.id}`}
          target="_blank"
          className="kit__utils__link font-size-16"
        >
          {record?.descripcion}
        </Link>
      ),
      width: '40%',
    },
    {
      title: 'Stock',
      dataIndex: 'stock',
      key: 'stock',
      render: (text, record) => record?.stock,
      width: '10%',
      sorter: {
        compare: (a, b) => a.stock - b.stock,
        multiple: 1,
      },
      defaultSortOrder: 'ascend',
    },
    {
      title: 'Stock Mín.',
      dataIndex: 'stockMinimo',
      key: 'stockMinimo',
      render: (text, record) => record?.stockMinimo,
      width: '10%',
      sorter: {
        compare: (a, b) => a.stock - b.stock,
        multiple: 2,
      },
    },
    {
      title: 'Últ. pedido',
      dataIndex: 'ultimoPedido',
      key: 'ultimoPedido',
      render: (text, record) => record?.fechaPedido,
      width: '10%',
      sorter: {
        compare: (a, b) => a.fechaPedido - b.fechaPedido,
        multiple: 2,
      },
    },
    {
      title: 'Agotado',
      dataIndex: 'agotado',
      key: 'agotado',
      render: (text, record) => (
        <>
          <Checkbox onChange={e => handleAgotar(record?.id, e.target.checked)} /> &nbsp;
          <DatePicker style={{ width: 120 }} />
        </>
      ),
      width: '10%',
    },
    {
      title: 'No mostrar',
      dataIndex: 'noMostrar',
      key: 'noMostrar',
      render: (text, record) => (
        <>
          <Checkbox onChange={e => handleNoMostrar(record?.id, e.target.checked)} />
        </>
      ),
      width: '10%',
    },
    {
      title: 'Usuario',
      dataIndex: 'usuario',
      key: 'usuario',
      render: (text, record) => (
        <>
          <Select
            placeholder="Seleccionar"
            options={mapUsuariosToSelectOptions()}
            onChange={value => handleSelectChange(record?.id, value)}
            defaultValue={record?.userId}
          />
        </>
      ),
      width: '10%',
    },
  ]

  const handleOk = () => {
    setVisible(false)
  }

  const handleSelectChange = (articuloId, value) => {
    // El usuario se almacena en el campo AlmacenExtra
    const articuloData = {
      Id: articuloId,
      AlmacenExtra: value,
    }
    updateArticuloUser(articuloData)
  }

  const handleNoMostrar = (articuloId, value) => {
    const articuloData = {
      Id: articuloId,
      Deleted: value,
    }
    updateArticuloUserMostrar(articuloData)
  }

  const handleAgotar = (articuloId, value) => {
    const articuloData = {
      Id: articuloId,
      Deleted: value,
    }
    updateArticuloAgotar(articuloData)
  }

  const handleShowTomorrow = () => {
    // Pospone el aviso hasta mañana
    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(today.getDate() + 1)
    const tomorrowISO = tomorrow.toISOString()
    patchUsuario(userId, [
      {
        op: 'replace',
        path: '/FechaStock',
        value: tomorrowISO,
      },
    ])
    setVisible(false)
  }

  const handleCancel = () => {
    setVisible(false)
  }

  const loading = articulos && articulos.loading

  return (
    <div>
      <Modal
        title="Artículos Faltantes"
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1200}
      >
        <div className="mb-4 kit__utils__table">
          <Table
            rowKey={record => record.id}
            columns={columns}
            dataSource={articulos.data}
            loading={loading}
            titulo=""
            pagination={{
              pageSizeOptions: ['10', '20', '50', '100', articulos?.data?.length],
              showSizeChanger: true,
              locale: { items_per_page: '' },
              position: ['bottomLeft'],
            }}
          />
        </div>
        <Popconfirm
          title="¿Ocultar mensaje hasta mañana?"
          onConfirm={handleShowTomorrow}
          okText="Mostrar mañana"
          cancelText="No"
        >
          <Button type="primary">
            No mostrar hasta mañana <FieldTimeOutlined />
          </Button>
        </Popconfirm>
      </Modal>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalStockMinimo)
